/* Heart Locket: slider, packs, personalização por locket e envio para o carrinho (uma linha por locket). */
(function () {
  'use strict';
  if (window.__hlLocketLoaded) return;
  window.__hlLocketLoaded = true;
  var MAX_MB = 20;

  function sliders(scope) {
    scope.querySelectorAll('[data-hl-gallery], [data-hl-reviews]').forEach(function (g) {
      var track = g.querySelector('[data-hl-track]');
      if (!track) return;
      var slides = track.children;
      var dotsBox = g.parentElement.querySelector('[data-hl-dots]');
      var step = function () { return slides.length ? slides[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth; };
      var prev = g.querySelector('[data-hl-prev]') || (g.parentElement.querySelector('[data-hl-prev]'));
      var next = g.querySelector('[data-hl-next]') || (g.parentElement.querySelector('[data-hl-next]'));
      var go = function (dir) {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (dir > 0 && track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
        else if (dir < 0 && track.scrollLeft <= 2) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        else track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      if (slides.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }
      if (dotsBox && slides.length > 1) {
        for (var i = 0; i < slides.length; i++) {
          var b = document.createElement('button');
          b.type = 'button'; b.setAttribute('aria-label', 'Go to image ' + (i + 1));
          (function (n) { b.addEventListener('click', function () { track.scrollTo({ left: n * step(), behavior: 'smooth' }); }); })(i);
          dotsBox.appendChild(b);
        }
        var mark = function () {
          var n = Math.round(track.scrollLeft / step());
          Array.prototype.forEach.call(dotsBox.children, function (d, j) { d.classList.toggle('is-active', j === n); });
        };
        track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
        mark();
      }
      g.hlGoTo = function (el) { if (el) track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: 'smooth' }); };
    });
  }

  function addBusinessDays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; }
    return r;
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }

  function delivery(scope) {
    var box = scope.querySelector('[data-hl-delivery]');
    if (!box) return;
    var n = function (k) { return parseInt(box.getAttribute('data-' + k), 10) || 0; };
    var today = new Date();
    var madeBy = addBusinessDays(today, n('prod-max'));
    var dMin = addBusinessDays(today, n('prod-min') + n('ship-min'));
    var dMax = addBusinessDays(today, n('prod-max') + n('ship-max'));
    box.querySelector('[data-hl-d="order"]').textContent = fmt(today);
    box.querySelector('[data-hl-d="made"]').textContent = 'By ' + fmt(madeBy);
    box.querySelector('[data-hl-d="deliver"]').textContent = fmt(dMin) + ' – ' + fmt(dMax);
    var hol = box.querySelector('[data-hl-holiday]');
    if (hol) {
      var until = hol.getAttribute('data-until');
      var iso = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
      hol.hidden = !!(until && iso > until);
    }
  }

  function inApp(scope) {
    var box = scope.querySelector('[data-hl-inapp]');
    if (!box) return;
    if (!/Instagram|FBAN|FBAV|FB_IAB|musical_ly|TikTok|Bytedance|Snapchat|Pinterest/i.test(navigator.userAgent)) return;
    box.hidden = false;
    box.querySelector('[data-hl-inapp-close]').addEventListener('click', function () { box.hidden = true; });
    var copy = box.querySelector('[data-hl-copy]');
    copy.addEventListener('click', function () {
      var url = window.location.href;
      var done = function () { copy.textContent = 'Copied ✓'; };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link:', url); });
      else window.prompt('Copy this link:', url);
    });
  }

  function main(root) {
    var form = root.querySelector('[data-hl-form]');
    if (!form) return;
    var packs = root.querySelectorAll('[data-hl-pack]');
    var pieces = root.querySelectorAll('[data-hl-piece]');
    var gallery = root.querySelector('[data-hl-gallery]');
    var atc = root.querySelector('[data-hl-atc]');
    var atcLabel = root.querySelector('[data-hl-atc-label]');
    var formError = root.querySelector('[data-hl-form-error]');
    var baseLabel = atcLabel.textContent;
    var qty = 1;

    function setPack(label) {
      packs.forEach(function (p) { p.classList.toggle('is-selected', p === label); });
      qty = parseInt(label.getAttribute('data-qty'), 10) || 1;
      root.querySelector('[data-hl-price-now]').textContent = label.getAttribute('data-now');
      root.querySelector('[data-hl-price-was]').textContent = label.getAttribute('data-was');
      var saveEl = root.querySelector('[data-hl-price-save]');
      var pct = parseInt(saveEl.getAttribute('data-pct'), 10) || 0;
      saveEl.textContent = 'SAVE ' + label.getAttribute('data-save') + (pct > 0 ? ' · ' + pct + '% OFF' : '');
      pieces.forEach(function (pc, i) {
        pc.hidden = i >= qty;
        pc.querySelector('[data-hl-legend]').textContent = qty > 1 ? 'Locket ' + (i + 1) + ' of ' + qty : 'Your locket';
      });
      atcLabel.textContent = qty > 1 ? baseLabel + ' · ' + qty + ' LOCKETS' : baseLabel;
    }
    packs.forEach(function (p) {
      p.querySelector('input').addEventListener('change', function () { setPack(p); });
    });
    var sel = root.querySelector('[data-hl-pack] input:checked');
    setPack(sel ? sel.closest('[data-hl-pack]') : packs[0]);

    pieces.forEach(function (pc, idx) {
      var colorName = pc.querySelector('[data-hl-color-name]');
      var initialSel = pc.querySelector('[data-prop="Initial"]');
      var initialPrev = pc.querySelector('[data-hl-initial-preview]');
      var uploads = pc.querySelector('.hl-uploads');
      var up2 = pc.querySelector('[data-hl-upload="2"]');

      function colorChanged(scroll) {
        var c = pc.querySelector('input[name^="hl-color"]:checked');
        if (!c) return;
        colorName.textContent = c.getAttribute('data-color-name');
        initialPrev.classList.toggle('is-silver', /silver/i.test(c.getAttribute('data-color-name')));
        if (scroll && idx === 0 && gallery && gallery.hlGoTo) {
          var mid = c.getAttribute('data-media-id');
          if (mid) gallery.hlGoTo(gallery.querySelector('[data-media-id="' + mid + '"]'));
        }
      }
      pc.addEventListener('change', function () {
        if (!pc.classList.contains('has-error')) return;
        pc.classList.remove('has-error');
        pc.querySelector('[data-hl-error]').hidden = true;
      });
      pc.querySelectorAll('input[name^="hl-color"]').forEach(function (r) { r.addEventListener('change', function () { colorChanged(true); }); });
      colorChanged(false);

      function countChanged() {
        var c = pc.querySelector('input[name^="hl-count"]:checked');
        var two = !c || c.value === '2';
        up2.hidden = !two;
        uploads.classList.toggle('is-single', !two);
      }
      pc.querySelectorAll('input[name^="hl-count"]').forEach(function (r) { r.addEventListener('change', countChanged); });
      countChanged();

      initialSel.addEventListener('change', function () {
        initialPrev.textContent = initialSel.value;
        initialSel.classList.toggle('is-missing', false);
      });

      pc.querySelectorAll('.hl-upload').forEach(function (lab) {
        var input = lab.querySelector('input[type=file]');
        var prev = lab.querySelector('[data-hl-preview]');
        var name = lab.querySelector('[data-hl-file]');
        var empty = name.textContent;
        var icon = prev.innerHTML;
        input.addEventListener('change', function () {
          var f = input.files && input.files[0];
          lab.classList.remove('is-missing');
          if (!f) { lab.classList.remove('is-filled'); prev.innerHTML = icon; name.textContent = empty; return; }
          if (f.size > MAX_MB * 1024 * 1024) {
            input.value = ''; lab.classList.remove('is-filled'); lab.classList.add('is-missing');
            prev.innerHTML = icon; name.textContent = 'Too large (max ' + MAX_MB + ' MB)';
            return;
          }
          lab.classList.add('is-filled');
          name.textContent = f.name;
          var img = document.createElement('img');
          img.alt = '';
          img.onerror = function () { prev.innerHTML = icon; }; /* HEIC em browsers que não o mostram: o ficheiro segue na mesma */
          img.src = URL.createObjectURL(f);
          prev.innerHTML = ''; prev.appendChild(img);
        });
      });
    });

    function validate() {
      var first = null;
      for (var i = 0; i < qty; i++) {
        var pc = pieces[i];
        var msgs = [];
        var count = (pc.querySelector('input[name^="hl-count"]:checked') || { value: '2' }).value;
        ['1', '2'].forEach(function (n) {
          if (n === '2' && count !== '2') return;
          var lab = pc.querySelector('[data-hl-upload="' + n + '"]');
          var ok = lab.querySelector('input').files.length > 0;
          lab.classList.toggle('is-missing', !ok);
          if (!ok) msgs.push('add photo ' + n);
        });
        var ini = pc.querySelector('[data-prop="Initial"]');
        /* inicial opcional (oferta final 2026-10-03): vazio = tampa lisa */
        if (!pc.querySelector('input[name^="hl-color"]:checked')) msgs.push('choose a color');
        var err = pc.querySelector('[data-hl-error]');
        if (msgs.length) {
          err.textContent = 'Please ' + (msgs.length > 1 ? msgs.slice(0, -1).join(', ') + ' and ' + msgs[msgs.length - 1] : msgs[0]) + '.';
          err.hidden = false; pc.classList.add('has-error');
          if (!first) first = pc;
        } else { err.hidden = true; pc.classList.remove('has-error'); }
      }
      return first;
    }

    function pieceData(pc, i) {
      var fd = new FormData();
      fd.append('id', pc.querySelector('input[name^="hl-color"]:checked').value);
      fd.append('quantity', '1');
      var count = (pc.querySelector('input[name^="hl-count"]:checked') || { value: '2' }).value;
      fd.append('properties[Photo 1]', pc.querySelector('[data-hl-upload="1"] input').files[0]);
      if (count === '2') fd.append('properties[Photo 2]', pc.querySelector('[data-hl-upload="2"] input').files[0]);
      fd.append('properties[Initial]', pc.querySelector('[data-prop="Initial"]').value || 'None (plain cover)');
      if (qty > 1) fd.append('properties[_Locket]', (i + 1) + ' of ' + qty);
      return fd;
    }

    var addUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js';
    var cartUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      formError.hidden = true;
      var bad = validate();
      if (bad) { bad.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      atc.disabled = true;
      atcLabel.textContent = 'UPLOADING YOUR PHOTOS…';
      var added = 0;
      var chain = Promise.resolve();
      for (var i = 0; i < qty; i++) {
        (function (n) {
          chain = chain.then(function () {
            return fetch(addUrl, { method: 'POST', body: pieceData(pieces[n], n), headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not add to cart'); added++; }); });
          });
        })(i);
      }
      chain.then(function () { window.location.href = cartUrl; })
        .catch(function (err) {
          atc.disabled = false;
          atcLabel.textContent = baseLabel;
          formError.textContent = (added ? added + ' of ' + qty + ' lockets were added. ' : '') + 'Something went wrong: ' + err.message + ' Please try again.';
          formError.hidden = false;
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-hl-main]').forEach(function (root) {
      sliders(root); delivery(root); inApp(root); main(root);
    });
    document.querySelectorAll('[data-hl-reviews-section]').forEach(sliders);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
